import React, { useRef, useState, useEffect, useContext } from "react";
import {
  Typography,
  Box,
  Grid,
  Stack,
  Button,
  Dialog,
  Divider,
  IconButton,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import ReactToPrint from "react-to-print";
import moment from "moment";
// import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
// import CheckBoxOutlineBlankOutlinedIcon from "@mui/icons-material/CheckBoxOutlineBlankOutlined";
import { ToWords } from "to-words";
import { BiMinusCircle } from "react-icons/bi";
// import { useMutation } from "@apollo/client";
//Import from project
import "../../../Style/pagestyle.scss";
import LogoSchool from "../../../Assets/logoSystem.png";
import WingdingImage from "../../../Assets/tacteing.jpg";
// import PaymentInvoice from "./PaymentInvoice";
import { AuthContext } from "../../../Context/AuthContext";
import {
  currencyFormat,
  // currencyFormatRiel,
  // generateInvoiceNumber,
} from "../../../Function/DynamicFn";
import { sumTwoNumber, minuseTwoNumber } from "../../../Function/DynamicFn";

const toWords = new ToWords({
  localeCode: "en-US",
  converterOptions: {
    currency: false,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: true,
  },
});

export default function PrintMultiInvoice({ open, handleClose, tableData }) {
  // Change Language
  const { t } = useContext(AuthContext);

  const totalAmount = tableData.reduce(
    (acc, curr) => acc + curr?.totalAmount,
    0
  );
  const totalOwe = tableData.reduce((acc, curr) => acc + curr?.totalOwe, 0);
  // console.log("tableData", tableData, totalAmount);

  // print
  const componentRef = useRef();
  const reactToPrintContent = () => {
    return componentRef.current;
  };

  const reactToPrintTrigger = () => {
    return (
      <Button
        sx={{
          width: "30%",
          padding: "6px",
          borderRadius: "10px",
          color: "white",
          backgroundColor: "#0f81c2 !important",
        }}
      >
        Print
      </Button>
    );
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {t("modal_title_view_invoice")}
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ marginTop: "10px" }}>
          <Grid container>
            <Grid item xs={3}>
              <Stack direction={"row"} justifyContent={"center"}>
                <img
                  src={LogoSchool}
                  alt="logo"
                  style={{ width: "130px", marginTop: "50px" }}
                />
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{ fontSize: "14px", fontFamily: "KhmerOsMuol" }}
                  align="center"
                >
                  ព្រះរាជាណាចក្រកម្ពុជា
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", fontFamily: "GothicBoldRegular" }}
                  align="center"
                >
                  Kingdom Of Cambodia
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", fontFamily: "KhmerOsMuol" }}
                  align="center"
                >
                  ជាតិ​ សាសនា ព្រះមហាក្សត្រ
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", fontFamily: "GothicBoldRegular" }}
                  align="center"
                >
                  Nation Religions King
                </Typography>
                <Stack direction="row" justifyContent="center">
                  <img
                    alt="Image"
                    src={WingdingImage}
                    className="print-invoice-tackteng"
                  />
                </Stack>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ marginTop: "20px" }}>
            <Grid container>
              <Grid item xs={4}>
                <Stack direction="column" spacing={0.5}>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      ឈ្មោះសហគ្រាស :
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      សាលាតន្ត្រីខេត្តសៀមរាប
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      អាសយដ្ឋាន៖
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      ភូមិមណ្ឌល៣ សង្កាត់ស្លក្រាម
                    </Typography>
                  </Stack>
                  <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}>
                    ក្រុងសៀមរាប ខេត្តសៀមរាប
                  </Typography>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      Tel :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      070 712 096
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" spacing={0.5}>
                  <Typography
                    sx={{ fontFamily: "Bayon", fontSize: "14px" }}
                    align="center"
                  >
                    <u>វិក្កយបត្រ</u>
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Baloopaaji",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                    align="center"
                  >
                    Invoice
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box>

          {tableData?.map((data, index) => {
            // console.log("data::", data);
            return (
              <Box key={index}>
                <Box sx={{ marginTop: "15px" }}>
                  <Typography
                    sx={{
                      fontFamily: "Siemreap",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    ព័ត៌មានសិស្ស/Student Information
                  </Typography>
                  <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
                  <Grid container>
                    <Grid item xs={6}>
                      <Stack
                        spacing={0.5}
                        direction="column"
                        sx={{ marginTop: "4px" }}
                      >
                        <Stack direction="row" spacing={0.5}>
                          <Typography
                            sx={{
                              fontFamily: "Siemreap",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            ឈ្មោះជាភាសាខ្មែរ/Full Name :
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                          >
                            {data?.studentId?.familyName +
                              " " +
                              data?.studentId?.studentName}
                          </Typography>
                        </Stack>
                        <Stack direction="row" spacing={0.5}>
                          <Typography
                            sx={{
                              fontFamily: "Siemreap",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            អត្តលេខ/Khmer ID :
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                          >
                            {data?.studentId?.studentId}
                          </Typography>
                        </Stack>
                        <Stack direction="row" spacing={0.5}>
                          <Typography
                            sx={{
                              fontFamily: "Siemreap",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            ភេទ/gender :
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                          >
                            {data?.studentId?.gender === "Male"
                              ? t("thead_male")
                              : t("thead_female")}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack
                        spacing={0.5}
                        direction="column"
                        sx={{ marginTop: "4px" }}
                      >
                        <Stack direction="row" spacing={0.5}>
                          <Typography
                            sx={{
                              fontFamily: "Siemreap",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            ថ្ងៃខែឆ្នាំកំណើត/Date of Birth :
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                          >
                            {moment(data?.studentId?.dob).format("DD-MMM-YYYY")}
                          </Typography>
                        </Stack>
                        <Stack direction="row" spacing={0.5}>
                          <Typography
                            sx={{
                              fontFamily: "Siemreap",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            លេខទូរស័ព្ទ/Tel :
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                          >
                            {data?.studentId?.phoneNumber}
                          </Typography>
                        </Stack>
                        <Stack direction="row" spacing={0.5}>
                          <Typography
                            sx={{
                              fontFamily: "Siemreap",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            ថ្នាក់/Class :
                          </Typography>
                          <Typography
                            sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                          >
                            {data?.enrollmentId?.classId?.courseId?.khName
                              ? data?.enrollmentId?.classId?.courseId?.khName +
                                " " +
                                data?.enrollmentId?.classId?.className
                              : ""}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Box sx={{ marginTop: "15px" }}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      ការបង់ថ្លៃ/Payment
                    </Typography>
                    <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
                  </Box>
                </Box>
                <table className="print-invoice-table1">
                  <tr>
                    <th style={{ width: "4%" }} align="left">
                      <div>ល.រ</div>
                      <div>N⁰</div>
                    </th>
                    <th style={{ width: "24%" }} align="left">
                      <div>បង់ថ្លៃ</div>
                      <div>Pay To</div>
                    </th>
                    <th style={{ width: "13%" }} align="left">
                      <div>ចាប់ទី</div>
                      <div>Start Date</div>
                    </th>
                    <th style={{ width: "13%" }} align="left">
                      <div>រហូតដល់</div>
                      <div>End Date</div>
                    </th>
                    <th style={{ width: "12%" }} align="right">
                      <div>តម្លៃ</div>
                      <div>Price</div>
                    </th>
                    <th style={{ width: "5%" }} align="right">
                      <div>ចំនួន</div>
                      <div>Qty</div>
                    </th>
                    <th style={{ width: "12%" }} align="right">
                      <div>បញ្ចុះតម្លៃ</div>
                      <div>Discount</div>
                    </th>
                    <th style={{ width: "15%" }} align="right">
                      <div>សរុប</div>
                      <div>Total Amount</div>
                    </th>
                  </tr>

                  {data?.items?.map((row, index) => {
                    // console.log("row::", row);
                    return (
                      <tr key={index}>
                        <td align="left">{index + 1}</td>
                        <td align="left">{row?.groupFeeId?.title}</td>
                        {/* <td align="left"></td> */}
                        <td align="left">
                          {row?.startDate
                            ? moment(row?.startDate).format("DD-MM-YYYY")
                            : ""}
                        </td>
                        <td align="left">
                          {row?.endDate
                            ? moment(row?.endDate).format("DD-MM-YYYY")
                            : ""}
                        </td>
                        <td align="right">
                          $ {currencyFormat(parseFloat(row?.price))}
                        </td>
                        <td align="right">{parseFloat(row?.qty)}</td>
                        <td align="right">
                          {row?.discountType === "amount" ? "$" : ""}{" "}
                          {row?.discountType === "amount"
                            ? currencyFormat(parseFloat(row?.discount))
                            : row?.discount}{" "}
                          {row?.discountType === "percentage" ? "%" : ""}{" "}
                        </td>
                        <td align="right">
                          $ {currencyFormat(parseFloat(row?.amount))}
                        </td>
                      </tr>
                    );
                  })}
                </table>
              </Box>
            );
          })}

          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ padding: "4px" }}
            >
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                សរុប (ដុល្លារ)/Total Amount ($) :
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                }}
              >
                $ {currencyFormat(parseFloat(totalAmount))}
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>

          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ padding: "4px" }}
            >
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ទទួល (ដុល្លារ)/Total Amount ($) :
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                }}
              >
                $ {currencyFormat(minuseTwoNumber(totalAmount, totalOwe))}
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>
          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ padding: "4px" }}
            >
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ជំពាក់ (ដុល្លារ)/Total Amount ($) :
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                }}
              >
                $ {currencyFormat(parseFloat(totalOwe))}
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>
          <Box>
            <Stack direction="row" spacing={0.4} sx={{ padding: "4px" }}>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ចំនួនទឹកប្រាក់ជាអក្សរ (ដុល្លារ)/Amount In Letter ($) :
              </Typography>
              <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}>
                {toWords.convert(parseFloat(totalAmount))} Dollar Only
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>

          <Box sx={{ marginTop: "50px" }}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <Box sx={{ border: "3px double #000", padding: "8px" }}>
                  <Typography
                    sx={{
                      fontFamily: "Bayon",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    ប្រាក់បង់រូចមិនអាចដក ផ្ទេរ និងរក្សាទុកបានទេ
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Siemreap",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    All processed payments will not be refunded, transfered, or
                    kept.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Stack
                  direction="column"
                  spacing={0.2}
                  sx={{ marginTop: "20px" }}
                >
                  <Divider sx={{ borderBottom: "1px solid #000" }} />
                  <Stack direction="row" spacing={0.2}>
                    <Typography sx={{ fontFamily: "Bayon", fontSize: "12px" }}>
                      អ្នកបង់ប្រាក់
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      (Payer)
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack
                  direction="column"
                  spacing={0.2}
                  sx={{ marginTop: "20px" }}
                >
                  <Divider sx={{ borderBottom: "1px solid #000" }} />
                  <Stack direction="row" spacing={0.2}>
                    <Typography sx={{ fontFamily: "Bayon", fontSize: "12px" }}>
                      បេឡាធិការ
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      (Cashier)
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* ============================================ code to print =============================================== */}

        <Stack direction="row" justifyContent="right">
          <ReactToPrint
            removeAfterPrint
            content={reactToPrintContent}
            trigger={reactToPrintTrigger}
            documentTitle={`${tableData?.studentId?.fullName}-invoice`}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
